import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/page/login.vue";
import password_trans from "@/page/password_trans.vue";
import password_account from "@/page/password_account.vue";
import my_coaching from "@/page/my_coaching/my_coaching.vue";
import next_coaching from "@/page/my_coaching/next_coaching.vue";
import embedded_survey_report from "@/page/my_coaching/embedded_survey_report.vue";
import schedule_change from "@/page/my_coaching/schedule_change.vue";
import reservation_coaching_view from "@/page/my_coaching/reservation_coaching_view.vue";
import message from "@/page/my_coaching/message.vue";
import coaching_request from "@/page/my_coaching/coaching_request.vue";
import coaching_message from "@/page/my_coaching/coaching_message.vue";
import payment_view from "@/page/payment/payment_view.vue";
import recom_video from "@/page/video/recom_video.vue";
import client_list from "@/page/coaching_journal/client_list.vue";
import coaching_journal_view from "@/page/coaching_journal/coaching_journal_view.vue";
import coaching_journal_write from "@/page/coaching_journal/coaching_journal_write.vue";
import coaching_journal_edit from "@/page/coaching_journal/coaching_journal_edit.vue";
import coaching_journal from "@/page/coaching_journal/coaching_journal.vue";
import myinfo from "@/page/myinfo.vue";
import reservation_coaching_request from "@/page/my_coaching/reservation_coaching_request.vue";
import client_detail from "@/page/coaching_journal/client_list_detail.vue";
import coaching_detail from "@/page/my_coaching/coaching_detail.vue";
import video_write from "@/page/video/video_write.vue";
import video_modify from "@/page/video/video_modify.vue";
import landing from "@/page/landing.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: login,
  },
  {
    path: "/password_trans/:idx/:isAccount",
    name: "password_trans",
    component: password_trans,
    props: true,
  },
  {
    path: "/password_account/:isAccount",
    name: "password_account",
    component: password_account,
    props: true,
  },
  {
    path: "/my_coaching",
    name: "my_coaching",
    component: my_coaching,
  },
  {
    path: "/next_coaching",
    name: "next_coaching",
    component: next_coaching,
  },
  {
    path: "/embedded_survey_report/:userIdx/:sessionIdx",
    name: "embedded_survey_report",
    component: embedded_survey_report,
    props: true,
  },
  {
    path: "/schedule_change/:sessionIdx",
    name: "schedule_change",
    component: schedule_change,
    props: true,
  },
  {
    path: "/reservation_coaching_view/:sessionIdx",
    name: "reservation_coaching_view",
    component: reservation_coaching_view,
    props: true,
  },
  {
    path: "/message/:userIdx",
    name: "message",
    component: message,
    props: true,
  },
  {
    path: "/coaching_request",
    name: "coaching_request",
    component: coaching_request,
  },
  {
    path: "/coaching_message",
    name: "coaching_message",
    component: coaching_message,
  },
  {
    path: "/payment_view",
    name: "payment_view",
    component: payment_view,
  },
  {
    path: "/recom_video",
    name: "recom_video",
    component: recom_video,
  },
  {
    path: "/client_list",
    name: "client_list",
    component: client_list,
  },
  {
    path: "/coaching_journal_view/:sessionIdx",
    name: "coaching_journal_view",
    component: coaching_journal_view,
    props: true,
  },
  {
    path: "/coaching_journal",
    name: "coaching_journal",
    component: coaching_journal,
  },
  {
    path: "/coaching_journal_write/:sessionIdx/:courseIdx",
    name: "coaching_journal_write",
    component: coaching_journal_write,
    props: true,
  },
  {
    path: "/coaching_journal_edit/:sessionIdx/:courseIdx",
    name: "coaching_journal_edit",
    component: coaching_journal_edit,
    props: true,
  },
  {
    path: "/myinfo",
    name: "myinfo",
    component: myinfo,
  },
  {
    path: "/reservation_coaching_request/:sessionIdx",
    name: "reservation_coaching_request",
    component: reservation_coaching_request,
    props: true,
  },
  {
    path: "/client_detail/:userIdx",
    name: "client_detail",
    component: client_detail,
    props: true,
  },
  {
    path: "/coaching_detail/:sessionIdx",
    name: "coaching_detail",
    component: coaching_detail,
    props: true,
  },
  {
    path: "/video_write/:isRetake/:userIdx",
    name: "video_write",
    component: video_write,
    props: true,
  },
  {
    path: "/video_modify/:contentIdx",
    name: "video_modify",
    component: video_modify,
    props: true,
  },
  {
    path: "/landing",
    name: "landing",
    component: landing,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
